// import React from "react";
// import IframeLoader from "../../IframeLoader";

// function MyCollection() {
//   return (
//     // <IframeLoader route="my-collection" />

//     // IF NEED UNCOMMENT  My Collection UI

//     <div>
//       <div className="my-collection">
//         <div className="collection">
//           <div className="collection-item">
//             <div className="collection-image">
//               <img
//                 src="https://cdn.pixabay.com/photo/2015/10/29/14/38/web-1012467__340.jpg"
//                 alt=""
//               />
//             </div>
//             <div className="collection-text">
//               <p>Iconic</p>
//               <p>750$</p>
//             </div>
//           </div>
//           <div className="collection-item">
//             <div className="collection-image">
//               <img
//                 src="https://cdn.pixabay.com/photo/2015/10/29/14/38/web-1012467__340.jpg"
//                 alt=""
//               />
//             </div>
//             <div className="collection-text">
//               <p>Iconic</p>
//               <p>750$</p>
//             </div>
//           </div>
//           <div className="collection-item">
//             <div className="collection-image">
//               <img
//                 src="https://cdn.pixabay.com/photo/2015/10/29/14/38/web-1012467__340.jpg"
//                 alt=""
//               />
//             </div>
//             <div className="collection-text">
//               <p>Iconic</p>
//               <p>750$</p>
//             </div>
//           </div>
//           <div className="collection-item">
//             <div className="collection-image">
//               <img
//                 src="https://cdn.pixabay.com/photo/2015/10/29/14/38/web-1012467__340.jpg"
//                 alt=""
//               />
//             </div>
//             <div className="collection-text">
//               <p>Iconic</p>
//               <p>750$</p>
//             </div>
//           </div>
//           <div className="collection-item">
//             <div className="collection-image">
//               <img
//                 src="https://cdn.pixabay.com/photo/2015/10/29/14/38/web-1012467__340.jpg"
//                 alt=""
//               />
//             </div>
//             <div className="collection-text">
//               <p>Iconic</p>
//               <p>750$</p>
//             </div>
//           </div>
//           <div className="collection-item">
//             <div className="collection-image">
//               <img
//                 src="https://cdn.pixabay.com/photo/2015/10/29/14/38/web-1012467__340.jpg"
//                 alt=""
//               />
//             </div>
//             <div className="collection-text">
//               <p>Iconic</p>
//               <p>750$</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default MyCollection;

import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  setClickedNFM,
  setCollectionItems,
  setStakedItems,
} from "../../../../store/actions/WalletActions";
import { BaseUrl, CollectionUrl } from "../../../../Shared";
import axios from "axios";
import "../../../../css/BuyNFM.css";

import clickit from "../../../../images/clickit.gif";
import nftimage from "../../../../images/rednft.png";
import stakedimage from "../../../../images/staked.png";
import Web3 from "web3";
import Cookies from "universal-cookie";
// import constant from "../../constants/_prodconstants";
import constants from "../../../../Shared/constants/constants";
import nftAbi from "../../../../Shared/nftAbi.json";
import nfmStakingAbi from "../../../../Shared/nfmStakingAbi.json";
import NFMDetailPage from "./NFMDetail";
import { getWalletAddress } from "../../../../store/selectors/WalletSelectors";
const cookies = new Cookies();

function MyCollection() {
  const dispatch = useDispatch();

  const connectedWallet = useSelector((state) => getWalletAddress(state)) || "";

  const tokenData = useSelector((state) => state.wallet.collectionItems) || [];
  const stakeTokenData = useSelector((state) => state.wallet.stakedItems) || [];

  const [clickedIndex, setClickedIndex] = useState(-1);
  const [connectionStatus, setConnectionStatus] = useState(null);
  const [web3, setWeb3] = useState(null);
  const [isWalletConnected, setWalletConnected] = useState(false);

  const fetchTokenInfo = async () => {
    let tempTokenData = JSON.parse(localStorage?.tokenData ?? "{}");

    let promiseArr = [];
    Object.entries(tempTokenData).forEach(async ([tier, indexArr]) => {
      for (let i = 0; i < indexArr.length; i++) {
        let item = axios.get(
          `${CollectionUrl}/${tier}/nft/metadata/${indexArr[i]}`,
          { timeout: 30000 }
        );
        promiseArr.push(item);
      }
    });

    axios
      .all(promiseArr)
      .then(
        axios.spread((...responses) => {
          dispatch(
            setCollectionItems(responses.map((response) => response.data))
          );
          localStorage.removeItem("tokenData");
        })
      )
      .catch((err) => {
        console.log(err, "error");
      });
  };

  const fetchStakeNFMInfo = async () => {
    let tempStakeTokenData = JSON.parse(localStorage?.stakeTokenData ?? "{}");
    let tempItem = {
      attributes: [
        { trait_type: "Background", value: "Light Green" },
        { trait_type: "Body", value: "Sizzlin" },
        { trait_type: "Shoes", value: "Yeezy Sneakers" },
        { trait_type: "Shirts", value: "Tank Top" },
        { trait_type: "Neck", value: "Bandana" },
        { trait_type: "Hand 2", value: "Egyptian Staff" },
        { trait_type: "Head", value: "Football Helmet" },
        { trait_type: "Eyewear", value: "Ski Goggles" },
        { trait_type: "Mouth", value: "Blade Of Wheat" },
        { trait_type: "Hand 1", value: "Bag Of Money" },
      ],
      description:
        "Missed out on wolf.game? Not to worry: we've got our very own Cops Vs. Bacons game, where you can stake your Bacon NFT's to earn $GREASE.",
      external_link: "https://www.grandtheftbacon.com",
      image: "https://api.grandtheftbacon.com/v1/nft/images/24.jpg",
      name: "Bacon #24",
    };

    let promiseArr = [];
    Object.entries(tempStakeTokenData).forEach(async ([tier, indexArr]) => {
      for (let i = 0; i < indexArr.length; i++) {
        let item = axios.get(
          `${CollectionUrl}/${tier}/nft/metadata/${indexArr[i]}`,
          { timeout: 30000 }
        );
        promiseArr.push(item);
      }
    });

    axios
      .all(promiseArr)
      .then(
        axios.spread((...responses) => {
          dispatch(setStakedItems(responses.map((response) => response.data)));
          localStorage.removeItem("stakeTokenData");
        })
      )
      .catch((err) => {
        console.log(err, "error");
      });
  };

  const fetchNFTsOfUser = async (wallet) => {
    console.log(
      `[nft][src][components][pages][MyCollectionTab][fetchNFTsOfUser] wallet`,
      wallet
    );
    try {
      let web3 = new Web3(window.ethereum);
      let Tier1 = await new web3.eth.Contract(
        nftAbi,
        constants.TIER_1_NFT_CONTRACT_ADDRESS
      );
      let Tier2 = await new web3.eth.Contract(
        nftAbi,
        constants.TIER_2_NFT_CONTRACT_ADDRESS
      );
      let Tier3 = await new web3.eth.Contract(
        nftAbi,
        constants.TIER_3_NFT_CONTRACT_ADDRESS
      );

      let tier1Balance = await Tier1.methods.balanceOf(wallet).call();
      let tier2Balance = await Tier2.methods.balanceOf(wallet).call();
      let tier3Balance = await Tier3.methods.balanceOf(wallet).call();

      let tier1NFTs = [];
      let tier2NFTs = [];
      let tier3NFTs = [];

      if (tier1Balance > 0) {
        for (let i = 0; i < tier1Balance; i++) {
          let token = await Tier1.methods.tokenOfOwnerByIndex(wallet, i).call();
          tier1NFTs.push(token);
        }
      }

      if (tier2Balance > 0) {
        for (let i = 0; i < tier2Balance; i++) {
          let token = await Tier2.methods.tokenOfOwnerByIndex(wallet, i).call();
          tier2NFTs.push(token);
        }
      }

      if (tier3Balance > 0) {
        for (let i = 0; i < tier3Balance; i++) {
          let token = await Tier3.methods.tokenOfOwnerByIndex(wallet, i).call();
          tier3NFTs.push(token);
        }
      }
      console.log(
        `[nft][src][components][pages][MyCollectionTab][fetchNFTsOfUser] tier1NFTs tokenIds`,
        tier1NFTs
      );
      console.log(
        `[nft][src][components][pages][MyCollectionTab][fetchNFTsOfUser] tier2NFTs tokenIds`,
        tier2NFTs
      );
      console.log(
        `[nft][src][components][pages][MyCollectionTab][fetchNFTsOfUser] tier3NFTs tokenIds`,
        tier3NFTs
      );
      localStorage.setItem(
        "tokenData",
        JSON.stringify({
          v1: tier1NFTs,
          v2: tier2NFTs,
          v3: tier3NFTs,
        })
      );
      fetchTokenInfo();
      await fetchStakedNFTsOfUser(wallet);
    } catch (error) {
      console.log(error, "error fetchNFT");
    }
  };

  const fetchStakedNFTsOfUser = async (wallet) => {
    console.log(
      `[nft][src][components][pages][MyCollectionTab][fetchStakedNFTsOfUser] wallet`,
      wallet
    );

    try {
      const web3 = new Web3(window.ethereum);

      let NFMStaking = await new web3.eth.Contract(
        nfmStakingAbi,
        constants.NFMSTAKING
      );

      let stakingTier1 = await NFMStaking.methods
        .getNoOfNFMsStakedByCollectionByUser(
          wallet,
          constants.TIER_1_NFT_CONTRACT_ADDRESS
        )
        .call();
      let stakingTier2 = await NFMStaking.methods
        .getNoOfNFMsStakedByCollectionByUser(
          wallet,
          constants.TIER_2_NFT_CONTRACT_ADDRESS
        )
        .call();
      let stakingTier3 = await NFMStaking.methods
        .getNoOfNFMsStakedByCollectionByUser(
          wallet,
          constants.TIER_3_NFT_CONTRACT_ADDRESS
        )
        .call();

      console.log(
        "[nft][src][components][pages][MyCollectionTab][fetchStakedNFTsOfUser]:: Tier1 Staked NFTs",
        stakingTier1
      );
      console.log(
        "[nft][src][components][pages][MyCollectionTab][fetchStakedNFTsOfUser]:: Tier2 Staked NFTs",
        stakingTier2
      );
      console.log(
        "[nft][src][components][pages][MyCollectionTab][fetchStakedNFTsOfUser]:: Tier3 Staked NFTs",
        stakingTier3
      );
      localStorage.setItem(
        "stakeTokenData",
        JSON.stringify({
          v1: stakingTier1,
          v2: stakingTier2,
          v3: stakingTier3,
        })
      );
      fetchStakeNFMInfo();
    } catch (error) {
      console.log(error, "error fetchStakedNFTsOfUser");
    }
  };

  useEffect(() => {
    let tokenDataLS = localStorage?.tokenData ?? "";
    let stakeTokenDataLS = localStorage?.stakeTokenData ?? "";
    // if (tokenDataLS && connectedWallet) {
    if (connectedWallet) {
      console.log("fetch is running");
      fetchNFTsOfUser(connectedWallet);
      fetchStakedNFTsOfUser(connectedWallet);
    }
  }, [connectedWallet]);

  const setItem = (type, index) => {
    setClickedIndex(index);
    let data = type === "tokenData" ? tokenData[index] : stakeTokenData[index];
    dispatch(setClickedNFM(data));
  };

  return (
    <>
      {clickedIndex >=0 ? <div
        style={{
          minWidth: "min-content",
          maxWidth: "80px",
          justifySelf: "flex-start",
          cursor: "pointer",
        }}
        className="gradient-button"
        onClick={() => setClickedIndex(-1)}
      >
        <i
          style={{ color: "white" }}
          className="fa fa-arrow-left"
          aria-hidden="true"
        ></i>{" "}
        Back
      </div> : null}
      <div
        className="row wow fade-in collection-boxes myct cldetail"
        style={{ marginTop: 0 }}
      >
        {clickedIndex < 0 ? (
          <div className=" nfm-detail">
            <div className="row">
              {tokenData.filter((data) => data).length &&
              connectedWallet.length ? (
                tokenData
                  .filter((data) => data)
                  .map((card, index) => {
                    if (!card) return null;
                    return (
                      <div
                        className="d-item col-lg-3 col-md-6 col-sm-6 col-xs-12"
                        key={card?.name + index}
                        onClick={() => {
                          setItem("tokenData", index);
                        }}
                      >
                        <div className="" key={card?.name + index}>
                          <div
                            className={`nft__item sold-out-nf${
                              clickedIndex === index ? " mobile__view" : ""
                            }`}
                          >
                            <div className="nft__item_wrap">
                              <a>
                                <img
                                  src={card?.image}
                                  className="lazy nft__item_preview"
                                  alt=""
                                />
                              </a>
                              <img
                                src={clickit}
                                id="iconclick"
                                onClick={() => {
                                  setClickedIndex(index);
                                }}
                                alt=""
                              />

                              <div className="sold-mark">
                                <img src={stakedimage} alt="" />
                              </div>
                              {/* <p className="sold-mark">

                              <span>SOLD</span>
                            </p> */}
                            </div>
                            <div className="nft__item_info text-center ow-justify-custom">
                              <div>
                                <p
                                  className="purple-text mb-0"
                                  style={{ fontSize: "0.9rem", color: "#333" }}
                                >
                                  {card?.name}
                                </p>
                                {/* <p>P #152412</p> */}
                              </div>

                              {card?.price ? (
                                <div className="text-right">
                                  {/* <p>450 $</p> */}
                                  <p className="pink-text">
                                    Price: ${card?.price}
                                  </p>
                                </div>
                              ) : null}
                            </div>

                            <button
                              className="gradient-button"
                              style={{
                                margin: "0 auto 1.5rem auto",
                                display: "block",
                              }}
                            >
                              Stake
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })
              ) : (
                <div style={{ width: "100vw", textAlign: "center" }}>
                    {!stakeTokenData.length ? <h1>No Items Found</h1> : null}
                </div>
              )}
            </div>

            <div className="staked-nfm ">
              {stakeTokenData.length && connectedWallet.length ? (
                <>
                  <br />
                  <h1 className="text-center">STAKED NFMs</h1>
                  <br />
                </>
              ) : null}

              <div className="row">
                {stakeTokenData.length && connectedWallet.length
                  ? stakeTokenData
                      .filter((data) => data)
                      .map((card, index) => {
                        if (!card) return null;
                        return (
                          <div
                            className="d-item col-lg-3 col-md-6 col-sm-6 col-xs-12"
                            key={card?.name + index}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setItem("stakeTokenData", index);
                            }}
                          >
                            <div
                              className={`nft__item sold-out-nft${
                                clickedIndex === index ? " mobile__view" : ""
                              }`}
                            >
                              <div className="nft__item_wrap">
                                <a>
                                  <img
                                    src={card?.image}
                                    className="lazy nft__item_preview"
                                    alt=""
                                  />
                                </a>
                                <img src={clickit} id="iconclick" alt="" />
                                <div className="sold-mark">
                                  <img src={stakedimage} alt="" />
                                </div>
                              </div>
                              <div className="nft__item_info row-justify-custom">
                                <div>
                                  <p
                                    className="color-dull"
                                    style={{ color: "#333" }}
                                  >
                                    {card?.name}
                                  </p>
                                </div>
                                {card?.price ? (
                                  <div className="text-right">
                                    <p className="pink-text">
                                      Price: ${card?.price}
                                    </p>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        );
                      })
                  : null}
              </div>
            </div>
          </div>
        ) : (
          <>
            <NFMDetailPage />
          </>
        )}
      </div>
      {clickedIndex < 0 ? (
        <p className="text-center my-4 min-height-23vh">
          NFMs airdrop process has started. We are airdropping NFM to the
          connected wallet upon final payment within 24-48 hours. Available NFMs
          from your connected wallet will be shown here
        </p>
      ) : null}
    </>
  );
}

export default MyCollection;
